import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FcpButtonModule } from '../fcp-button';
import { FcpIconModule } from '../fcp-icon';
import { FcpAlertComponent } from './fcp-alert.component';

@NgModule({
    declarations: [FcpAlertComponent],
    imports: [CommonModule, FcpIconModule, FcpButtonModule],
    exports: [FcpAlertComponent]
})
export class FcpAlertModule {}
